import { render, staticRenderFns } from "./ScheduleBoard.vue?vue&type=template&id=f1645f2a&scoped=true&"
import script from "./ScheduleBoard.vue?vue&type=script&lang=js&"
export * from "./ScheduleBoard.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleBoard.vue?vue&type=style&index=0&id=f1645f2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1645f2a",
  null
  
)

export default component.exports